import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withDonate from '../../components/guest/WithDonate';
import TeslaForm from './teslaForm';
import {
  loadProgressiveOnboarding,
  loadSlickProgressiveOnboarding,
} from '../../utility/lazyLoader';
import TemplateData from '../../utility/getTemplateData';
import * as FPT from '../../utility/fpt';
import _get from 'lodash/get';

let SignupApp;
let signUpAppEvents;
let Progressiveonboarding;

export class TeslaFormContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      progressiveComponentLoaded: false,
    };
  }
  componentDidMount() {
    this.props.toggleSpinner(true);
    const shouldLoadSlickBundle = this.shouldLoadSlickBundle();
    FPT.addOnboardingBundleType(shouldLoadSlickBundle ? 'slick' : 'full');
    this.lazyLoadProgressiveComponent(shouldLoadSlickBundle);
  }

  shouldLoadSlickBundle() {
    return _get(
      TemplateData,
      'pxp.portableOnboardingFullVsSlick.experiment',
      false
    );
  }

  lazyLoadProgressiveComponent = (isSlickBundle) => {
    if (isSlickBundle) {
      loadSlickProgressiveOnboarding().then((loadedModules) => {
        Progressiveonboarding = loadedModules[0];
        SignupApp = Progressiveonboarding.SignupApp;
        signUpAppEvents = Progressiveonboarding.clientListeners;
        this.setState({
          progressiveComponentLoaded: true,
        });
      });
    } else {
      loadProgressiveOnboarding().then((loadedModules) => {
        Progressiveonboarding = loadedModules[0];
        SignupApp = Progressiveonboarding.SignupApp;
        signUpAppEvents = Progressiveonboarding.clientListeners;
        this.setState({
          progressiveComponentLoaded: true,
        });
      });
    }
  };

  render() {
    if (!this.state.progressiveComponentLoaded) {
      return null;
    }

    return (
      <TeslaForm
        signupApp={SignupApp}
        signUpAppEvents={signUpAppEvents}
        {...this.props}
      />
    );
  }
}

TeslaFormContainer.propTypes = {
  toggleSpinner: PropTypes.func,
};

export default withDonate(TeslaFormContainer);
